
import * as _ from 'lodash';

const initialState = {
  loader:{
    show : false
  }
}

export const loader = {
  state: initialState,
  actions: {
    changeLoader({commit},payload){
      commit('changeLoaderSuccess', payload)
    }
  },
  getters: {
    loader: state => state.loader
  },
  mutations: {
    changeLoaderSuccess(state, loader) {
      state.loader = loader;
    }
  },   
};

export default loader;



// WEBPACK FOOTER //
// ./src/store/loader.module.js